import React, { memo } from 'react';
import Image from 'next/image';
import Link from 'next/link';

import { IButton, ITypo } from '@/app/_components/common';
import { Wrapper } from '@/app/_components/layout';
import { Icons } from '@/app/assets/Icons';
import { ROUTERS } from '@/constants';

const SubHeader = () => {
	return (
		<article className="bg-mauvelous col">
			<Wrapper className="row-between relative">
				<div className="hidden sm:block">
					<Image
						src={Icons.header.book}
						width={48}
						height={40}
						alt="DLA Da Nang"
					/>
				</div>

				<div className="row relative flex-wrap gap-x-2 lg:absolute lg:left-1/2 lg:-translate-x-1/2">
					<ITypo
						size={12}
						as="p"
						weight="semi"
						className="bg-pink-to-yellow text-linear sm:text-18 lg:text-24"
					>
						SĨ SỐ SIÊU NHỎ - HỌC PHÍ SIÊU YÊU
					</ITypo>
					<ITypo
						size={10}
						as="p"
						className="bg-pink-to-yellow text-linear sm:text-14"
					>
						Offline - Online toàn quốc{' '}
					</ITypo>
				</div>

				<Link href={ROUTERS.EXAMINATION}>
					<IButton className="bg-pink-to-yellow h-fit min-h-[22px] min-w-[106px] rounded-lg">
						<ITypo size={10} weight="semi" className="sm:text-16">
							<span className="hidden lg:inline">Đăng ký </span>
							Thi thử miễn phí
						</ITypo>
					</IButton>
				</Link>
			</Wrapper>
		</article>
	);
};

export default memo(SubHeader);
